import { largeNumberDisplay } from '@/utils/helpers';

function setLargeNumber(el, binding) {
  el.innerHTML = largeNumberDisplay(binding.value || 0);
}

export default {
  bind(el, binding) {
    setLargeNumber(el, binding);
  },
  update(el, binding) {
    setLargeNumber(el, binding);
  },
};



// WEBPACK FOOTER //
// ./src/directives/large-number.js